var map = {
	"./bottom-nav-bg.png": 1395,
	"./bottom-nav-bg.webp": 1396,
	"./btn-active.png": 1397,
	"./btn-deco.webp": 1398,
	"./content-deco-1.webp": 1399,
	"./content-deco-2.webp": 1400,
	"./content-deco-3.webp": 1401,
	"./content-deco-4.webp": 1402,
	"./content-deco-5.webp": 1403,
	"./content-deco-6.webp": 1404,
	"./convenient.webp": 1405,
	"./deposit-icon.webp": 1406,
	"./home-icon-active.webp": 1407,
	"./home-icon.webp": 1408,
	"./live-icon-active.webp": 1409,
	"./live-icon.webp": 1410,
	"./me-icon-active.webp": 1411,
	"./me-icon.webp": 1412,
	"./product-overview-bg.webp": 1413,
	"./professional.webp": 1414,
	"./promos-icon-active.webp": 1415,
	"./promos-icon.webp": 1416,
	"./raya-bg.png": 1417,
	"./safety.webp": 1418,
	"./services-bg.png": 1419,
	"./speed.webp": 1420,
	"./sponsor-icon-active.webp": 1421,
	"./sponsor-icon.webp": 1422,
	"./vip-icon.webp": 1423,
	"./withdraw-icon.webp": 1424,
	"./wwr-img.webp": 1425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 146;